import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class TeamAuthGuardGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const ssoToken = next.queryParamMap.get('t');
    if (ssoToken) {
      return true;
    }

    const userId = sessionStorage.getItem('userId');
    const fullName = sessionStorage.getItem('FullName');

    if (!userId || !fullName || userId === 'null' || fullName === 'null') {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }

}
